(() => {
  const key = 'aboutp-delivery-country';
  let selectedCountry;
  try { selectedCountry = sessionStorage.getItem(key); } catch {}

  const update = (root) => {
    const selector = root.querySelector('[data-ap-country]');
    if (!selector) return;
    const option = [...selector.options].find((item) => item.value === selectedCountry);
    if (option) selector.value = option.value;
    const isEU = selector.selectedOptions[0]?.dataset.apEu === 'true';
    const rate = root.querySelector('[data-ap-rate]');
    const rateText = isEU ? root.dataset.apEuRate : root.dataset.apOutsideRate;
    if (rate && rate.textContent !== rateText) rate.textContent = rateText;
    const total = root.querySelector('[data-ap-total]');
    const totalText = isEU ? root.dataset.apEuTotal : root.dataset.apOutsideTotal;
    if (total && total.textContent !== totalText) total.textContent = totalText;
    const showTotal = isEU || root.dataset.apCurrency === 'EUR';
    const totalRow = root.querySelector('[data-ap-total-row]');
    const currencyNote = root.querySelector('[data-ap-currency-note]');
    const importNote = root.querySelector('[data-ap-import]');
    if (totalRow) totalRow.hidden = !showTotal;
    if (currencyNote) currencyNote.hidden = showTotal;
    const showImportNotice = selector.selectedOptions[0]?.dataset.apCustoms;
    if (importNote) importNote.hidden = showImportNotice === undefined ? isEU : showImportNotice !== 'true';
  };

  const refresh = () => document.querySelectorAll('[data-ap-shipping]').forEach(update);

  document.addEventListener('change', (event) => {
    const selector = event.target.closest('[data-ap-country]');
    if (!selector) return;
    selectedCountry = selector.value;
    try { sessionStorage.setItem(key, selectedCountry); } catch {}
    refresh();
  });

  const start = () => {
    refresh();
    new MutationObserver((records) => {
      if (records.some((record) => [...record.addedNodes].some((node) =>
        node.nodeType === 1 && (node.matches('[data-ap-shipping]') || node.querySelector('[data-ap-shipping]'))
      ))) refresh();
    }).observe(document.body, { childList: true, subtree: true });
  };

  document.addEventListener('shopify:section:load', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();


